import FreelancerActiveStatusEnum from '../../../../Enums/FreelancerActiveStatusEnum';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import EditFreelancerUserHelper from '../EditFreelancerUserHelper';

export default class GeneralData {
  //#region Validation
  static validityCheckerForEmail(e, editedItem) {
    const validityResult = ValidityHelper.forEmailRequired(e);

    if (validityResult !== '') {
      return validityResult;
    }

    return EditFreelancerUserHelper.validityCheckerDataExistsInDatabase(
      'Email',
      e,
      'This email address belongs to another user.',
      editedItem.FreelancerUserId
    );
  }
  //#endregion

  //#region OnChange
  static onOfficeChange(editedItem, isPaymentOfficeChange) {
    const officeId = editedItem.PaymentOfficeId ? editedItem.PaymentOfficeId : editedItem.OfficeId;

    if (officeId.toString() === '7') {
      editedItem.ContractorLocationCountryId = 44;
    } else if (officeId.toString() === '14') {
      editedItem.ContractorLocationCountryId = 142;
    } else {
      editedItem.ContractorLocationCountryId = null;
    }

    if (isPaymentOfficeChange !== true) {
      GeneralData.UpdateBillingFields(editedItem);
    }

    editedItem.PaymentMethod = EditFreelancerUserHelper.getDefaultPaymentMethodValue(editedItem);
    editedItem.PaymentCurrencyId = EditFreelancerUserHelper.getDefaultPaymentCurrencyValue(editedItem);

    if (editedItem.PaymentOfficeId && editedItem.OfficeId && !(editedItem.FreelancerUserId > 0)) {
      editedItem.CurrencyId = EditFreelancerUserHelper.getDefaultBillingCurrencyValue(editedItem);
    }
  }

  static onActiveStatusChange(editedItem) {
    //The active status field is not an actual field, it's a derived state
    const selectedOption = editedItem.ActiveStatus;
    if (selectedOption) {
      editedItem.IsActive = selectedOption === FreelancerActiveStatusEnum.ActiveEngaged;
      editedItem.IsOffboarded = selectedOption === FreelancerActiveStatusEnum.InactiveOffboarded;
    }
  }
  //#endregion

  static UpdateBillingFields(editedItem) {
    editedItem.InvoiceNeeded = EditFreelancerUserHelper.getDefaultInvoiceNeededValue(editedItem);
    editedItem.CurrencyId = null;

    const prevPaymentOfficeValue = editedItem.PaymentOfficeId;
    editedItem.PaymentOfficeId = null;

    if (prevPaymentOfficeValue !== null) {
      GeneralData.onOfficeChange(editedItem, true);
    }
  }

  static returnDescriptionTab() {
    return {
      label: 'General',
      fields: [
        {
          fieldName: 'FirstName',
          label: 'First Name',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'LastName',
          label: 'Last Name',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'Email',
          label: 'E-mail',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: GeneralData.validityCheckerForEmail,
        },
        {
          fieldName: 'PhoneNumber',
          label: 'Phone Number',
          className: 'col-6',
          type: InputTypesEnum.PhoneNumber,
          validityChecker: ValidityHelper.forRequiredPhoneNumber,
        },
        {
          fieldName: 'OfficeId',
          label: 'Office',
          className: 'col-12',
          type: InputTypesEnum.OfficeSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
          onFieldChange: GeneralData.onOfficeChange,
        },
        {
          fieldName: 'PaymentOfficeId',
          label: 'Alternate Vendor Payment Office',
          className: 'col-12',
          type: InputTypesEnum.PaymentOfficeSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
          idFilter: 'OfficeId',
          isCheckBoxEnabled: true,
          tooltipText: "The Office's alternate offices for paying vendors",
          disabled: (item) => !item.OfficeId,
          onFieldChange: (item) => GeneralData.onOfficeChange(item, true),
        },
        {
          fieldName: 'ActiveStatus',
          label: 'Active?',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: EditFreelancerUserHelper.getSelectOptionsForActiveStatus,
          validityChecker: ValidityHelper.forRequiredSelectField,
          hide: (item) => !item.FreelancerUserId,
          onFieldChange: GeneralData.onActiveStatusChange,
        },
        {
          fieldName: 'CurrencyId',
          label: 'Fee Currency',
          className: 'col-12',
          type: InputTypesEnum.CurrencySelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
          hide: (item) => !item.PaymentOfficeId,
          info: 'Currency is Payment Office Billing Currency.',
        },
      ],
    };
  }
}
